import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBlack, IBlacksInitialState, IBlacksList } from '@types';

import { initialBlacks } from './initialState';

export const blacksSlice = createSlice({
    name: 'blacks',
    initialState: initialBlacks(),
    reducers: {
        setBlacks(state: IBlacksInitialState, action: PayloadAction<IBlacksList>) {
            state.blacksList = action.payload;
        },

        setBlack(state: IBlacksInitialState, action: PayloadAction<IBlack | null>) {
            state.black = action.payload;
        },
    },
});
